import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';

const useCardShapeIdsByCards = (cardIds: string[] | undefined) : string[] | undefined => {
  const cardShapeDb = useSelector((state: RootState) => state.cardShapeDb);
  if (cardIds === undefined) return;
  let ids: string[] = [];
  cardIds.forEach(cardId => {
    const shapeIds = Object.keys(cardShapeDb.cardShapes).filter(id => cardShapeDb.cardShapes[id].cardId === cardId);
    ids.push(...shapeIds);
  })
  return ids;
}

export default useCardShapeIdsByCards;
